import { Component } from "@angular/core";
import { NavParams, ViewController } from "ionic-angular";

interface PickerItem {
  name: String;
  selected: Boolean;
  singleSelect?: Boolean;
}

@Component({
  selector: "co-picker",
  templateUrl: "co-picker.component.html",
})
export class CoPickerComponent {
  valueChangedFunction: Function;
  title: String;
  items: Array<PickerItem>;
  updatingCheckList: Boolean = false;

  constructor(private _navParams: NavParams,private _viewCtrl: ViewController) {
    if (this._navParams.data && this._navParams.data.hasOwnProperty("valueChanged")) {
      this.valueChangedFunction = this._navParams.get("valueChanged");
    }
    if (this._navParams.data && this._navParams.data.hasOwnProperty("items")) {
      this.items = this._navParams.get("items");
    }
  }
  changeValue(index) {
    let selectionState: boolean = !this.items[index].selected;
    if (this.updatingCheckList == false) {
        setTimeout(() => {
            this.updatingCheckList = true;
            if (this.items[index].singleSelect && selectionState == true) {
                this.items.forEach((item) => {
                  item.selected = false;
                });
            } else {
                this.items.forEach((item) => {
                  if (item.singleSelect && item.selected == true) {
                    item.selected = false;
                  }
                });
            }
            this.items[index].selected = selectionState;
            this.updatingCheckList = false;
            this.valueChangedFunction(this.items);
        })
    }
  }
  close() {
    this._viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/components/co-picker/co-picker.component.ts